import Ordering from './Ordering'

export default Ordering